import { useEffect, useState } from "react";
import api from "../api/api";
import SideNavLayout from "../Sidenav/SideNavLayout";
import ToastMessage from "../utils/muitoast";

import CircularProgress from "@mui/material/CircularProgress";
import Backdrop from "@mui/material/Backdrop";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft, faEye, faTrash, faUpload } from "@fortawesome/free-solid-svg-icons";
import { faGripVertical } from "@fortawesome/free-solid-svg-icons";

import UploadManualModal from "./uploadmanual.jsx";
import ConfirmDeleteModal from "./deleteconformation.jsx";
import { useNavigate, useSearchParams } from "react-router-dom";
import {
  DndContext,
  closestCenter,
} from "@dnd-kit/core";

import {
  arrayMove,
  SortableContext,
  useSortable,
  verticalListSortingStrategy,
} from "@dnd-kit/sortable";

import { CSS } from "@dnd-kit/utilities";

const ManualDoc = () => {
  /* ================= STATE ================= */
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [loader, setLoader] = useState(false);
const [deleteloader,setDeleteLoader]=useState(false)
const navigate = useNavigate();
  const [search, setSearch] = useState("");
  const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [selectedIds, setSelectedIds] = useState([]);
const[uploadloader,setUploadLoader]=useState(false)
  /* Upload */
  const [uploadOpen, setUploadOpen] = useState(false);
const [file, setFile] = useState([]);
  const [searchParams] = useSearchParams();
  /* Delete confirmation */
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [deleteIds, setDeleteIds] = useState([]);
  const [deleteFileName, setDeleteFileName] = useState("");
  const [isBulkDelete, setIsBulkDelete] = useState(false);

  /* Toast */
  const [open, setOpen] = useState(false);
  const [severity, setSeverity] = useState("success");
  const [alertMessage, setAlertMessage] = useState("");
   const documentType = searchParams.get("type");
  const handleCloseToast = () => setOpen(false);

  /* ================= FETCH ================= */
  // const fetchData = async (skipLoader) => {
  //   try {
  //     if (!skipLoader) setLoading(true);


  //   const res = await api.get(
  //     `/v1/documents/manual/get-all`,
  //     {
  //       params: {
  //         document_type: documentType,   // 🔥 THIS LINE
  //       },
  //     }
  //   );
  //     setData(res.status === 200 ? res.data || [] : []);
  //   } catch (err) {
  //     console.error(err);
  //     setData([]);
  //   } finally {
  //     setLoading(false);
  //   }
  // };
const fetchData = async (skipLoader) => {
  try {
    if (!skipLoader) setLoading(true);

    const res = await api.get(`/v1/documents/manual/get-all`, {
      params: { document_type: documentType },
    });

    let list = res.status === 200 ? res.data || [] : [];

    // 🔥 normalize positions
    const hasAnyPosition = list.some((d) => d.position_id !== null);

    if (!hasAnyPosition) {
      // all null → use created_at order
      list = list.sort(
        (a, b) => new Date(a.created_at) - new Date(b.created_at)
      );
    } else {
      // use backend order
      list = list.sort(
        (a, b) => (a.position_id ?? 99999) - (b.position_id ?? 99999)
      );
    }

    setData(list);
  } catch (err) {
    console.error(err);
    setData([]);
  } finally {
    setLoading(false);
  }
};

  useEffect(() => {
    fetchData();
  }, []);

  /* ================= UPLOAD ================= */
const uploadDoc = async () => {
  if (!file || file.length === 0) return;

  const type = searchParams.get("type");

  if (!type) {
    setSeverity("error");
    setAlertMessage("No category selected");
    setOpen(true);
    return;
  }

  try {
    setUploadLoader(true);

    for (const f of file) {
      const formData = new FormData();
      formData.append("file", f);
      formData.append("document_type", type);

      await api.post("/v1/documents/manual/upload", formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });
    }

    setSeverity("success");
    setAlertMessage("Documents uploaded successfully");
    setOpen(true);
// after upload success


// get latest list from backend
const latest = await api.get("/v1/documents/manual/get-all", {
  params: { document_type: documentType },
});

let list = latest.status === 200 ? latest.data || [] : [];

// normalize order same as fetchData
const hasAnyPosition = list.some((d) => d.position_id !== null);

if (!hasAnyPosition) {
  list = list.sort(
    (a, b) => new Date(a.created_at) - new Date(b.created_at)
  );
} else {
  list = list.sort(
    (a, b) => (a.position_id ?? 99999) - (b.position_id ?? 99999)
  );
}

// 🔥 move uploaded items to top
const uploadedCount = file.length;

const newItems = list.slice(-uploadedCount);
const rest = list.slice(0, -uploadedCount);

const newOrder = [...newItems, ...rest];

// 🔥 CALL ORDER API FIRST
await updateOrder(newOrder);
 fetchData(true);
// 🔥 THEN update UI
setData(newOrder);

setUploadOpen(false);
setFile([]);


  } catch (err) {
    console.error(err);
    setSeverity("error");
    setAlertMessage("Upload failed");
    setOpen(true);
  } finally {
    setUploadLoader(false);
  }
};

  /* ================= DELETE ================= */
  const deleteDocs = async (docIds = []) => {
    if (!docIds.length) return;

    try {
      setDeleteLoader(true);
      const res = await api.delete(
        "/v1/documents/manual/delete",
        {
          data: { doc_ids: docIds },
          headers: { "Content-Type": "application/json" },
        }
      );

      if (res.status === 200) {
        setSelectedIds([]);
        setSeverity("success");
        setAlertMessage("Document(s) deleted successfully");
        setOpen(true);
        fetchData(true);
      } else {
        throw new Error();
      }
    } catch {
      setSeverity("error");
      setAlertMessage("Failed to delete document(s)");
      setOpen(true);
    } finally {
      setDeleteLoader(false);
    }
  };
const updateOrder = async (newData) => {
  const payload = {
    document_type: documentType,
    documents: newData.map((item, index) => ({
      id: item.id,
      display_order: index + 1,
    })),
  };

  await api.put("/v1/documents/manual/reorder", payload);
};

const handleDragEnd = async (event) => {
  const { active, over } = event;
  if (!over || active.id === over.id) return;

  // page start index in full data
  const startIndex = (page - 1) * rowsPerPage;

  // get only current page slice
  const pageItems = data.slice(startIndex, startIndex + rowsPerPage);

  const oldIndex = pageItems.findIndex(i => i.id === active.id);
  const newIndex = pageItems.findIndex(i => i.id === over.id);

  const newPageOrder = arrayMove(pageItems, oldIndex, newIndex);

  // merge back into full list
  const newFullData = [...data];
  newFullData.splice(startIndex, rowsPerPage, ...newPageOrder);

  setData(newFullData);

  // 🔥 SEND ALL IDS ORDERED
  await updateOrder(newFullData);
};

const SortableRow = ({ item, children }) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
  } = useSortable({ id: item.id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  };

  return (
    <tr ref={setNodeRef} style={style}>
      {children({ attributes, listeners })}
    </tr>
  );
};


  const handleDelete = (id, fileName) => {
    setDeleteIds([id]);
    setDeleteFileName(fileName);
    setIsBulkDelete(false);
    setConfirmOpen(true);
  };

  const handleBulkDelete = () => {
    setDeleteIds(selectedIds);
    setDeleteFileName("");
    setIsBulkDelete(true);
    setConfirmOpen(true);
  };

  const confirmDelete = async () => {
    await deleteDocs(deleteIds);
    setConfirmOpen(false);
  };

  /* ================= TABLE ================= */
  const filteredData = data.filter((d) =>
    d.file_name?.toLowerCase().includes(search.toLowerCase())
  );

  const totalPages = Math.ceil(filteredData.length / rowsPerPage) || 1;
  const paginatedData = filteredData.slice(
    (page - 1) * rowsPerPage,
    page * rowsPerPage
  );

  const toggleSelect = (id) => {
    setSelectedIds((prev) =>
      prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id]
    );
  };
const allSelected =
  paginatedData.length > 0 &&
  paginatedData.every((d) => selectedIds.includes(d.id));

const someSelected =
  paginatedData.some((d) => selectedIds.includes(d.id)) && !allSelected;

const toggleSelectAll = () => {
  if (allSelected) {
    // deselect only current page items
    setSelectedIds((prev) =>
      prev.filter((id) => !paginatedData.some((d) => d.id === id))
    );
  } else {
    // select current page items
    const pageIds = paginatedData.map((d) => d.id);
    setSelectedIds((prev) => Array.from(new Set([...prev, ...pageIds])));
  }
};
if (!documentType) {
  return (
    <SideNavLayout>
      <div className="flex items-center justify-center h-[70vh]">
        <div className="text-center">
          <h2 className="text-xl font-semibold text-red-600">
            No Category Selected
          </h2>
          <p className="text-gray-500 mt-2">
            Please go back and select a manual category.
          </p>
        </div>
      </div>
    </SideNavLayout>
  );
}


  const handleView = (url) => window.open(url, "_blank");

  /* ================= RENDER ================= */
  return (
    <SideNavLayout>
      <div className="max-w-6xl mx-auto mt-6 bg-white rounded-xl shadow-md p-4">

        {/* HEADER */}
        <div className="flex justify-between items-center mb-4">
       
<div className="flex items-center gap-3">
    <button
      onClick={() => navigate(-1)}
      className="w-9 h-9 flex items-center justify-center rounded-full border hover:bg-gray-100"
    >
      <FontAwesomeIcon icon={faArrowLeft} />
    </button>

    <h2 className="font-semibold text-lg">
    {documentType ? `${documentType}` : ""}
    </h2>
  </div>
          <div className="flex items-center gap-2">
            <button
              onClick={() => setUploadOpen(true)}
              className="bg-black text-white px-3 py-1.5 text-sm rounded flex items-center gap-2"
            >
              <FontAwesomeIcon icon={faUpload} />
              Upload
            </button>

            <input
              type="text"
              placeholder="Search..."
              value={search}
              onChange={(e) => {
                setSearch(e.target.value);
                setPage(1);
              }}
              className="border rounded px-3 py-1.5 text-sm w-48"
            />

            {selectedIds.length > 0 && (
              <button
                onClick={handleBulkDelete}
                className="bg-red-600 text-white px-3 py-1.5 text-sm rounded"
              >
                Delete Selected
              </button>
            )}
          </div>
        </div>

        {/* TABLE */}
        <table className="w-full text-sm border text-start">
          <thead className="bg-gray-100">
            <tr>
              <th className="p-2 text-left"></th>
              <th className="p-2 text-center w-10">
               <input
  type="checkbox"
  checked={allSelected}
  ref={(el) => {
    if (el) el.indeterminate = someSelected;
  }}
  onChange={toggleSelectAll}
/>

              </th>
              <th className="p-2 text-left">File Name</th>
              <th className="p-2 text-left">Created By</th>
              <th className="p-2 text-left">Date</th>
              <th className="p-2 text-center">Actions</th>
            </tr>
          </thead>
<DndContext collisionDetection={closestCenter} onDragEnd={handleDragEnd}>
  <SortableContext
    items={paginatedData.map((i) => i.id)}
    strategy={verticalListSortingStrategy}
  >
    <tbody>
      {loading && (
        <tr>
          <td colSpan="5" className="py-10 text-center">
            <CircularProgress />
          </td>
        </tr>
      )}

    {!loading &&
 paginatedData.map((item) => (
    <SortableRow key={item.id} item={item}>
      {({ attributes, listeners }) => (
        <>
          {/* DRAG ICON COLUMN */}
          <td className="p-2 w-10 text-center">
            <span
              {...attributes}
              {...listeners}
              className="cursor-grab text-gray-400 hover:text-black"
            >
              <FontAwesomeIcon icon={faGripVertical} />
            </span>
          </td>

          {/* CHECKBOX */}
          <td className="p-2">
            <input
              type="checkbox"
              checked={selectedIds.includes(item.id)}
              onChange={() => toggleSelect(item.id)}
            />
          </td>

          <td className="p-2">{item.file_name}</td>
          <td className="p-2">{item.created_by}</td>
          <td className="p-2">{item.created_at}</td>

          <td className="p-2 text-center space-x-2">
            <button
              onClick={() => handleView(item.document_url)}
              className="w-8 h-8 rounded-full bg-blue-600 text-white"
            >
              <FontAwesomeIcon icon={faEye} />
            </button>

            <button
              onClick={() => handleDelete(item.id, item.file_name)}
              className="w-8 h-8 rounded-full bg-red-600 text-white"
            >
              <FontAwesomeIcon icon={faTrash} />
            </button>
          </td>
        </>
      )}
    </SortableRow>
  ))}

    </tbody>
  </SortableContext>
</DndContext>

        </table>

        {/* PAGINATION */}
        <div className="flex justify-between items-center mt-4">
          <div className="flex items-center gap-2 text-sm">
            Rows per page:
            <select
              value={rowsPerPage}
              onChange={(e) => {
                setRowsPerPage(Number(e.target.value));
                setPage(1);
              }}
              className="border rounded px-2 py-1"
            >
              {[5, 10, 20].map((n) => (
                <option key={n} value={n}>{n}</option>
              ))}
            </select>
          </div>

          <div className="flex items-center gap-2">
            <button
              disabled={page === 1}
              onClick={() => setPage((p) => p - 1)}
              className="px-3 py-1 border rounded disabled:opacity-40"
            >
              Previous
            </button>

            <span className="text-sm">
              Page {page} of {totalPages}
            </span>

            <button
              disabled={page === totalPages}
              onClick={() => setPage((p) => p + 1)}
              className="px-3 py-1 border rounded disabled:opacity-40"
            >
              Next
            </button>
          </div>
        </div>
      </div>

   <UploadManualModal
  open={uploadOpen}
  onClose={() => setUploadOpen(false)}
  file={file}
  setFile={setFile}
  onUpload={uploadDoc}
  loading={uploadloader}
/>


      <ConfirmDeleteModal
        open={confirmOpen}
        onClose={() => setConfirmOpen(false)}
        onConfirm={confirmDelete}
        fileName={deleteFileName}
        isBulk={isBulkDelete}
        loading={deleteloader}
      />

      {/* BACKDROP */}
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={loader}
      >
        <CircularProgress color="inherit" />
      </Backdrop>

      <ToastMessage
        message={alertMessage}
        severity={severity}
        open={open}
        handleClose={handleCloseToast}
      />
    </SideNavLayout>
  );
};

export default ManualDoc;
